import * as React from 'react';
import { api, applyQueryString, handleApiError } from 'services/api';
import type {
  ViagemControle,
  ViagensControleIndicators,
  ViagensControleFilters,
  ViagensControlePaginatedResponse,
  ViagensControlePaginationControl,
} from 'pages/viagens-controle/types';

type Payload = {
  filters?: ViagensControleFilters;
  pagination?: ViagensControlePaginationControl;
  approveOrRejectOnly?: boolean;
};

export const useFetchViagensControle = () => {
  const fetchViagensControle = React.useCallback(async (payload: Payload) => {
    const path = payload.approveOrRejectOnly
      ? '/viagens-controle/approve-or-reject'
      : '/viagens-controle';
    const url = applyQueryString(path, {
      ...payload.filters,
      ...payload.pagination,
    });

    try {
      const { data } = await api.get<ViagensControlePaginatedResponse>(url);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  const fetchViagemControleById = React.useCallback(async (id: number) => {
    try {
      const { data } = await api.get<ViagemControle>(`/viagens-controle/${id}`);
      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  const fetchViagensControleIndicators = React.useCallback(
    async (filters?: ViagensControleFilters) => {
      const url = applyQueryString('/viagens-controle/indicators', {
        ...filters,
      });

      try {
        const { data } = await api.get<ViagensControleIndicators>(url);
        return data;
      } catch (e) {
        throw handleApiError(e);
      }
    },
    []
  );

  return {
    fetchViagensControle,
    fetchViagemControleById,
    fetchViagensControleIndicators,
  };
};
